import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref, reactive, toRaw, computed, onBeforeMount, watchEffect, unref } from 'vue'
import { useRoute } from 'vue-router'
import { cloneDeep } from 'lodash-es'
import vueQr from 'vue-qr/src/packages/vue-qr.vue'
import { goBack } from '@/hooks/cosRouter'
import { message } from '@dc-platform/dc-components'
import { selectForNumberValidate } from '@/utils/validate'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import { listByParamCodes } from '@/api/common'
import { ActivityCodeEditParams } from '@/typings/api/marketingManage'
import {
  activityCreate,
  activityUpdate,
  activityDetail,
  partnerDropList,
  templateList
} from '@/api/marketing/marketingManage'
import { useCopyToClipboard } from '@/hooks/useCopyToClipboard'
import { paramCodesDataFilter, downloadFileByBase64 } from '@/utils/index'
import type { FormInstance } from 'ant-design-vue'
import type { ParamCodeItem } from '@/typings/common'

const __default__ = { name: 'DetailForm' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    type: {},
    subdomain: {},
    title: {},
    paramCode: {}
  },
  setup(__props: any) {

const { clipboardRef, copiedRef } = useCopyToClipboard()

const props = __props
watchEffect(() => {
  if (props.type === 'view' && props.subdomain == null) {
    console.error('当详情页时, props subdomain 必传')
  }
})
const columns = ref([
  { title: '销售员', dataIndex: 'followerName' },
  { title: '操作', dataIndex: 'action', width: 170 }
])

const permissionPage = computed(() => {
  const addPermissions = {
    fbu: { save: 'fbu_activity_add_btn' },
    lbu: { save: 'lbu_activity_add_btn' }
  }
  const otherPermissions = {
    fbu: { edit: 'fbu_activity_edit_btn', save: 'fbu_activity_edit_btn' },
    lbu: { edit: 'lbu_activity_edit_btn', save: 'lbu_activity_edit_btn' }
  }
  return props.type === 'add' ? addPermissions[props.subdomain] : otherPermissions[props.subdomain]
})
const paramCodeData = ref<{
  [key: string]: ParamCodeItem[]
}>({
  [props.paramCode]: [] // 来源渠道
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_zbu',
    paramCodes: [props.paramCode]
  }).then((res) => {
    if (props.type !== 'view') {
      // 递归过滤业务参数状态
      res.data = paramCodesDataFilter(res.data, 0)
    }
    paramCodeData.value = res.data
  })
}
const partnerEnum = ref()
const getPartner = () => {
  partnerDropList().then((res) => {
    partnerEnum.value = res.data
  })
}
const templateEnum = ref<any[]>([])
const pageUtils = reactive({ pageNumber: 1, pageSize: 100 })
const getTemplate = () => {
  templateList(pageUtils).then((res) => {
    templateEnum.value = [...templateEnum.value, ...res.data.items]
  })
}
const popupScroll = (e: any) => {
  const { scrollHeight, scrollTop, clientHeight } = e.target
  if (scrollHeight - scrollTop === clientHeight) {
    pageUtils.pageNumber = pageUtils.pageNumber + 1
    getTemplate()
  }
}
onBeforeMount(() => {
  getByParamCodes()
  getPartner()
  getTemplate()
})

const loading = ref(false)
const formRef = ref<FormInstance>()
const queryId = computed(() => route.query.id as string)
const initForm = reactive<ActivityCodeEditParams>({
  activityName: undefined,
  channelId: undefined,
  follower: undefined,
  startTime: undefined,
  endTime: undefined,
  partnerId: undefined,
  activityTemplateId: undefined,
  remark: undefined
})
const dataForm = reactive<ActivityCodeEditParams>(cloneDeep(initForm))
const formRules = reactive({
  input: [{ required: true, message: '请输入' }],
  select: [{ required: true, message: '请选择' }],
  selectNumber: [{ required: true, validator: selectForNumberValidate }]
})

const route = useRoute()
const getDetails = () => {
  loading.value = true
  activityDetail({ activityQrcodeId: route.query.id as string })
    .then((res) => {
      if (props.type === 'edit') {
        res.data.activityQrcodeId = res.data.id
      }
      Object.assign(initForm, res.data)
      Object.assign(dataForm, res.data)
    })
    .finally(() => {
      loading.value = false
    })
}
onBeforeMount(() => {
  if (props.type !== 'add') {
    getDetails()
  }
})

const handleSubmitAdd = () => {
  loading.value = true
  activityCreate(toRaw(dataForm))
    .then(() => {
      message.success('新增活码成功')
      goBack()
    })
    .finally(() => {
      loading.value = false
    })
}
const handleSubmitEdit = () => {
  loading.value = true
  activityUpdate(toRaw(dataForm))
    .then(() => {
      message.success('修改活码成功')
      goBack()
    })
    .finally(() => {
      loading.value = false
    })
}

const onSubmit = () => {
  if (props.type === 'add') {
    handleSubmitAdd()
  } else if (props.type === 'edit') {
    handleSubmitEdit()
  }
}

const qrCodeRef = ref()
const qrCodeTitle = ref('')
const visible = ref<boolean>(false)
const currentRow = ref()
const qrCodeType = ref<'zh-CN' | 'en-US'>()
const qrCodeUrl = ref('')
const qrCodeLogoEnum = {
  fbu: require('@/assets/logo_gucang.png'),
  lbu: require('@/assets/logo_yuntu.png')
}
const handleCopy = () => {
  clipboardRef.value = qrCodeUrl.value
  if (unref(copiedRef)) {
    message.success('复制成功')
  } else {
    message.error('该浏览器不支持自动复制!')
  }
}
const showModal = (lang: 'zh-CN' | 'en-US', row: any) => {
  const langEnum = { 'zh-CN': '中文二维码', 'en-US': '英文二维码' }
  qrCodeType.value = lang
  qrCodeTitle.value = langEnum[lang]
  currentRow.value = row
  qrCodeUrl.value = `${window.WEB_URL}/mobile.html#/businessCard?cardId=${row.id}&follower=${row.follower}&subdomain=${props.subdomain}&lang=${qrCodeType.value}`
  visible.value = true
}
const handleOk = () => {
  downloadFileByBase64(qrCodeRef.value.imgUrl, `${currentRow.value?.followerName}-${qrCodeType.value}`)
  visible.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_CosInput = _resolveComponent("CosInput")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_CosRangePicker = _resolveComponent("CosRangePicker")!
  const _component_CosSelect = _resolveComponent("CosSelect")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_CosTextarea = _resolveComponent("CosTextarea")!
  const _component_dc_layout_card = _resolveComponent("dc-layout-card")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_MoreButton = _resolveComponent("MoreButton")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_form, {
      ref_key: "formRef",
      ref: formRef,
      model: dataForm,
      autocomplete: "off",
      scrollToFirstError: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_dc_layout_card, {
          title: props.title,
          span: 6
        }, {
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, {
              label: "活动名称",
              name: "activityName",
              rules: formRules.input
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: dataForm.activityName,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataForm.activityName) = $event)),
                  maxlength: 100,
                  disabled: props.type === 'view',
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              label: "来源渠道",
              name: "channelId",
              rules: formRules.select
            }, {
              default: _withCtx(() => [
                _createVNode(ParamCodeCascader, {
                  value: dataForm.channelId,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((dataForm.channelId) = $event)),
                  options: paramCodeData.value[props.paramCode],
                  disabled: props.type === 'view',
                  view: props.type === 'view'
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              label: "活动负责人",
              name: "follower",
              rules: formRules.select
            }, {
              default: _withCtx(() => [
                _createVNode(_component_UserSelect, {
                  value: dataForm.follower,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((dataForm.follower) = $event)),
                  disabled: props.type === 'view',
                  view: props.type === 'view',
                  allowClear: ""
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              label: "开始结束时间",
              name: "startTime",
              rules: formRules.select
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosRangePicker, {
                  startTime: dataForm.startTime,
                  "onUpdate:startTime": _cache[3] || (_cache[3] = ($event: any) => ((dataForm.startTime) = $event)),
                  endTime: dataForm.endTime,
                  "onUpdate:endTime": _cache[4] || (_cache[4] = ($event: any) => ((dataForm.endTime) = $event)),
                  disabled: props.type === 'view',
                  view: props.type === 'view'
                }, null, 8, ["startTime", "endTime", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              label: "合作伙伴",
              name: "partnerId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosSelect, {
                  value: dataForm.partnerId,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((dataForm.partnerId) = $event)),
                  fieldNames: { label: 'name', value: 'id' },
                  options: partnerEnum.value,
                  disabled: props.type === 'view',
                  view: props.type === 'view',
                  allowClear: ""
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "选择模板",
              name: "activityTemplateId",
              rules: formRules.selectNumber
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosSelect, {
                  value: dataForm.activityTemplateId,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((dataForm.activityTemplateId) = $event)),
                  fieldNames: { label: 'name', value: 'id' },
                  options: templateEnum.value,
                  disabled: props.type === 'view',
                  view: props.type === 'view',
                  onPopupScroll: popupScroll,
                  allowClear: ""
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_a_col, { span: 24 }),
            _createVNode(_component_dc_form_item, {
              label: "备注",
              name: "remark",
              span: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosTextarea, {
                  value: dataForm.remark,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((dataForm.remark) = $event)),
                  maxlength: 2000,
                  disabled: props.type === 'view',
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["title"]),
        (props.type === 'view')
          ? (_openBlock(), _createBlock(_component_dc_layout_card, {
              key: 0,
              title: "销售名片",
              span: 24
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_cos_table, {
                      columns: columns.value,
                      dataSource: dataForm.businessCardVoList,
                      tableId: props.subdomain === 'fbu' ? 'DcCosFbuActivityCodeViewCardList' : 'DcCosLbuActivityCodeViewCardList',
                      needPage: false
                    }, {
                      bodyCell: _withCtx(({ column, record }) => [
                        (column.dataIndex === 'action')
                          ? (_openBlock(), _createBlock(_component_MoreButton, { key: 0 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_button, {
                                  type: "link",
                                  onClick: ($event: any) => (showModal('zh-CN', record))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("中文二维码")
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]),
                                _createVNode(_component_a_button, {
                                  type: "link",
                                  onClick: ($event: any) => (showModal('en-US', record))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("英文二维码")
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["columns", "dataSource", "tableId"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_modal, {
                  visible: visible.value,
                  "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((visible).value = $event)),
                  title: qrCodeTitle.value,
                  onOk: handleOk
                }, {
                  footer: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      key: "submit",
                      type: "primary",
                      onClick: handleCopy
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("复制链接")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_button, {
                      key: "submit",
                      type: "primary",
                      onClick: handleOk
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("下载二维码")
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(vueQr, {
                      margin: 0,
                      size: 400,
                      text: qrCodeUrl.value,
                      logoSrc: qrCodeLogoEnum[props.subdomain],
                      logoScale: 0.25,
                      logoMargin: 6,
                      correctLevel: 0,
                      ref_key: "qrCodeRef",
                      ref: qrCodeRef
                    }, null, 8, ["text", "logoSrc"])
                  ]),
                  _: 1
                }, 8, ["visible", "title"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_cos_footer_button, {
      value: dataForm,
      "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((dataForm) = $event)),
      formRef: formRef.value,
      resetValue: initForm,
      loading: loading.value,
      disabled: props.type === 'view',
      permissionPage: permissionPage.value,
      editUrl: `/${props.subdomain}/activityCode/edit?id=${queryId.value}`,
      onSubmit: onSubmit
    }, null, 8, ["value", "formRef", "resetValue", "loading", "disabled", "permissionPage", "editUrl"])
  ], 64))
}
}

})